import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { constants } from "../constants";
import routes from "../routers/helpers/routes";
import { init} from "./handleTokens";
import UserContext from "./UserContext";

const UserState = (props) => {


    useEffect(()=> {
        console.log('renderizando usestate...')
    })
    const initialUser= {
        name: '',
        organization: '',
        email: '',
        imageUrl: '',
        role:'user',
        admin: false,
    }
    const [user, setUser] = useState(initialUser);


    const requestUser = async() => {
        try {
            const result = await init();
            console.log( result +' continuamos...')
            const token = window.localStorage.getItem('at');
            const URL = constants.test_host + '/user/valid-user'
            const {data}= await axios.get(URL, {headers:{ 'authorization': `Bearer ${token}` , 'Content-Type': 'application/json'}, withCredentials: true})
            return setUser(data.user)
        } catch (error) {
            console.log(error)
            return
        } 
    }

    const getUser = async() => {
        await requestUser();
    }

    const hasRole = (role) => {
        if(user && role=== 'admin' && user.admin) return true
        if(user && user.role === role) return true
        if(!user || user.role !== role) return null
    }

    const isLogged = () => {
        return user.name !== '' ? true : false
    }


    return (
        <UserContext.Provider value= {{user, setUser, getUser, hasRole, isLogged}}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserState;